
import '../App.css';
import '../css/ImageGrid.css'

import { Tooltip } from "react-tooltip";
import { getdailylookDetail } from '../network/get_dailylookDetail';
import { postDailylookComment } from '../network/post_dailtlookComment';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { getweeklybest } from '../network/get_weeklybest';
import { gethomebanner } from '../network/get_homebanner';
import { getDailylookComment } from '../network/get_dailylookComment';
import { FaSearch } from 'react-icons/fa';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getHashtagMoodPosts } from '../network/get_hashtagMoodPosts';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 

import { useSearchParams, useNavigate } from 'react-router-dom';

import { MdArrowBackIos, MdOutlineIosShare } from "react-icons/md";
import { FaHeart } from "react-icons/fa";

import { getpopularKeywords } from '../network/get_popularKeywords';

import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 

import { getMoodPost } from '../network/get_moodPosts';

// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 


const KEY_OPTIONS = Array.from({ length: 61 }, (_, i) => 140 + i);

const TimeAgo = ({ isoString }) => {
  // 1. dayjs 객체 생성
  const time = dayjs(isoString);
  
  // 2. 현재 시간으로부터 상대적인 시간을 계산 (예: "1년 전", "2시간 전")
  const timeAgoText = time.fromNow();

  return (
    <span title={isoString}>
      {timeAgoText}
    </span>
  );
};

function Search() {

    const [searchParams] = useSearchParams();

  // URL에서 특정 인자(key)의 값을 가져옴


  

 
  async function processData() {
  // await loginPost("temp", "temp_user")
    const postId = searchParams.get('id');    // 예: '123'
  console.log(postId)
  if(postId != ''){
    setSearchTerm(postId)
    handleSearch(postId);

  }

    const popularKeywordsData = await getpopularKeywords()
const cleanKeywords = popularKeywordsData.map(keyword => 
  keyword.replace(/#/g, '')
);

// 2. new Set()을 사용하여 중복 제거 (cleanKeywords 배열 사용)
const uniqueKeywords = [...new Set(cleanKeywords)];

console.log(uniqueKeywords);

// 3. 중복이 제거된 배열에서 상위 5개만 저장
setPopularKeywords(uniqueKeywords.slice(0, 5));
    //   setDailylook(dailylookdetail)
    MoodfetchPosts()


  
}


    const seletesex = [
    { label: '전체', value: 'ALL' },
    { label: '남성', value: 'M' },
    { label: '여성', value: 'W' },
  ];

    const seletebodytype = [
    { label: '전체', value: 'ALL' },
    { label: '마른', value: '마른' },
    { label: '슬림', value: '슬림' },
    { label: '보통', value: '보통' },
    { label: '통통한', value: '통통한' },
    { label: '근육질', value: '근육질' },
    { label: '체격있는', value: '체격있는' },
  ];

      const seanson = [
    { label: '전체', value: '' },
    { label: '봄', value: '봄' },
    { label: '여름', value: '여름' },
    { label: '가을', value: '가을' },
    { label: '겨울', value: '겨울' },

  ];

  const MOOD_OPTIONS = [
  '캐주얼', '스트릿', '웜마일', '아메카지', '시티보이', '스포티',
  '러블리', '놈코어', '프레피',
  '고프코어', '댄디', '에스닉', '매니쉬',
  '로맨틱', '레트로', '걸리시', '워크웨어', '페미닌'
];

const BASE_URL = 'http://52.79.160.172:8001';
const PAGE_SIZE = 15; // 한 번에 가져올 항목 수

   const [posts, setPosts] = useState([]);
  // 현재 페이지 상태 (다음 요청에 사용될 offset 값)
  const [pageKey, setPageKey] = useState(0);
  // 더 불러올 데이터가 있는지 여부
  const [hasMore, setHasMore] = useState(true);


     const [moodposts, setmoodPosts] = useState([]);
  // 현재 페이지 상태 (다음 요청에 사용될 offset 값)
  const [moodpageKey, setmoodPageKey] = useState(0);
  // 더 불러올 데이터가 있는지 여부
  const [moodhasMore, setmoodHasMore] = useState(true);

    const [ismoodLoading, setmoodIsLoading] = useState(false);
  // 로딩 상태 (불필요한 중복 요청 방지)
  const [isLoading, setIsLoading] = useState(false);


      const [isModalOpen, setIsModalOpen] = useState(false);
          const [isMoodModalOpen, setIsMoodModalOpen] = useState(false);
    const [minHeightState, setMinHeightState] = useState(160); // 초기 최소 키
    const [maxHeightState, setMaxHeightState] = useState(180); // 초기 최대 키
      const [finalSelection, setFinalSelection] = useState([]);
      const [searchTerm, setSearchTerm] = useState('');
      const [genderTerm, setGenderTerm] = useState('');
      const [bodyTerm, setBodyTerm] = useState('');
      const [finalSearchTerm, setFinalSearchTerm] = useState(''); 

          const [buttonIndex, setButtonIndex] = useState(0); // 초기 최대 키

           const [seansonTerm, setSeansonTerm] = useState('');
      
      const [popularKeywords, setPopularKeywords] = useState([]);


      const [openDropdown, setOpenDropdown] = useState(null);

      const handleSaveSettings = (min, max) => {
            setButtonIndex(1)
    setMinHeightState(min);
    setMaxHeightState(max);
    console.log(`설정 저장됨: 최소 ${min}cm, 최대 ${max}cm`);
  };


function MoodTag({ mood, isSelected, onClick }) {
  const style = {
    ...styles.tagBase,
    // 선택 상태에 따라 스타일 변경
    ...(isSelected ? styles.tagSelected : styles.tagDefault),
  };

  return (
    <button onClick={onClick} style={style}>
      {mood}
    </button>
  );
}

const moodpageKeyRef = useRef(moodpageKey);
useEffect(() => {

    moodpageKeyRef.current = moodpageKey;

}, [moodpageKey]); 

const pageKeyRef = useRef(pageKey);
useEffect(() => {

    pageKeyRef.current = pageKey;

}, [pageKey]); 

const fetchPosts = useCallback(async () => {
    // 주의: 함수 내부에서 최신 posts.length를 사용하지 않으므로 posts는 의존성에서 제외
     const currentPageKey = pageKeyRef.current; 
if (isLoading || !hasMore) {
        console.log(`로딩 중단: isLoading=${isLoading}, hasMore=${hasMore}`);
        return; // 호출 중단
    }


    setIsLoading(true);
    console.log(currentPageKey)

    
    try {
      const response = await getHashtagMoodPosts(
        BASE_URL,
        currentPageKey, // 최신 pageKey 사용
        PAGE_SIZE,
        finalSearchTerm,
        finalSelection,
        seansonTerm,
        {
          bodyType :bodyTerm,
          gender : genderTerm,
          minHeight: minHeightState,
          maxHeight: maxHeightState
        }
      );
      
      const newPosts = response.results || [];
      const totalCount = response.total_count;

      // 이전 상태를 기반으로 업데이트해야 정확함
      setPosts(prevPosts => {
          const updatedPosts = [...prevPosts, ...newPosts];
          
          // *주의: posts.length 대신 updatedPosts.length를 사용해야 정확함*
          if (updatedPosts.length >= totalCount) {
              setHasMore(false);
          }
          return updatedPosts;
      });
      
     setPageKey(pageKeyRef.current + PAGE_SIZE); // 함수형 업데이트를 사용하여 최신 pageKey 보장
      
    } catch (error) {
      console.error("데이터 로딩 실패:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
}, [finalSearchTerm, genderTerm, seansonTerm,finalSelection,bodyTerm,minHeightState, maxHeightState]);


async function MoodfetchPosts () {
    // 주의: 함수 내부에서 최신 posts.length를 사용하지 않으므로 posts는 의존성에서 제외
     const currentPageKey = moodpageKeyRef.current; 
if (ismoodLoading || !moodhasMore) {
        console.log(`로딩 중단: isLoading=${ismoodLoading}, hasMore=${moodhasMore}`);
        return; // 호출 중단
    }


    setmoodIsLoading(true);
    console.log(currentPageKey)

    
    try {
      const response = await getMoodPost(
        currentPageKey, // 최신 pageKey 사용
        PAGE_SIZE,
      );
      
      const newPosts = response.results || [];
      const totalCount = response.count;

      // 이전 상태를 기반으로 업데이트해야 정확함
      setmoodPosts(prevPosts => {
          const updatedPosts = [...prevPosts, ...newPosts];
          
          // *주의: posts.length 대신 updatedPosts.length를 사용해야 정확함*
          if (updatedPosts.length >= totalCount) {
              setmoodHasMore(false);
          }
          return updatedPosts;
      });
      
     setmoodPageKey(moodpageKeyRef.current + PAGE_SIZE); // 함수형 업데이트를 사용하여 최신 pageKey 보장
      
    } catch (error) {
      console.error("데이터 로딩 실패:", error);
      setmoodHasMore(false);
    } finally {
      setmoodIsLoading(false);
    }
};


  const handleConfirmSelection = (selection) => {
    setFinalSelection(selection);
    console.log("최종 선택 무드:", selection);
    // 선택된 데이터를 API 요청에 사용하거나 상태에 저장합니다.
  };

    const goToPostDetail = (postId, postCategory) => {
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion
    const queryParams = new URLSearchParams({
      id: postId,
      category: postCategory
    }).toString();

    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/dailylook?${queryParams}`);
  };
    


  function MoodSelectionModal({ isOpen, onClose, onConfirm }) {
    const [selectedMoods, setSelectedMoods] = useState([]); // 선택된 무드 배열 상태
  
    // 태그 클릭 핸들러
    const handleTagClick = (mood) => {
      // 이미 선택된 항목인지 확인
      const isCurrentlySelected = selectedMoods.includes(mood);
  
      if (isCurrentlySelected) {
        // 이미 선택되어 있다면 -> 선택 해제 (배열에서 제거)
        setSelectedMoods(selectedMoods.filter(m => m !== mood));
      } else {
        // 선택되어 있지 않다면
        if (selectedMoods.length < 3) {
          // 최대 3개 미만일 때만 추가
          setSelectedMoods([...selectedMoods, mood]);
        } else {
          // 최대 3개일 때 추가 선택 시도 -> 경고 메시지
          alert("최대 3개까지만 선택 가능합니다.");
        }
      }
    };
  
    // '선택' 버튼 클릭 핸들러
    const handleConfirm = () => {
      onConfirm(selectedMoods); // 선택된 무드를 상위 컴포넌트로 전달
      onClose();
    };
  
    if (!isOpen) return null; // 모달이 닫힌 상태면 렌더링하지 않음
  
    return (
      <div style={modalStyles.backdrop}>
        <div style={modalStyles.content}>
          
          {/* 헤더 */}
          <h3 style={styles.modalHeader}>무드 선택</h3>
          <p style={styles.modalSubtitle}>최대 3개까지 선택이 가능합니다.</p>
          
          {/* 태그 목록 영역 */}
          <div style={styles.tagsGrid}>
            {MOOD_OPTIONS.map((mood) => (
              <MoodTag
                key={mood}
                mood={mood}
                isSelected={selectedMoods.includes(mood)}
                onClick={() => handleTagClick(mood)}
              />
            ))}
          </div>
          
          {/* 선택 버튼 */}
          <button onClick={handleConfirm} style={styles.confirmButton}>
            선택
          </button>
        </div>
      </div>
    );
  }



function Dropdown({ title, items, type, isOpen, onToggle }) {
  const [selectedItem, setSelectedItem] = useState(title);

  const handleSelect = (item) => {
    setSelectedItem(item.label);
    if (type === 'g') setGenderTerm(item.value);
    else if (type === 'b') setBodyTerm(item.value);
    else if (type === 's') setSeansonTerm(item.value);

    setPageKey(0);
    setButtonIndex(1);
    onToggle(null); // 선택 후 드롭다운 닫기
  };

  return (
    <div style={styles.dropdownContainer}>
      <button 
        onClick={() => onToggle(isOpen ? null : type)} 
        style={styles.dropdownButton}
      >
        {selectedItem}
        <span style={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <ul style={styles.dropdownMenu}>
          {items.map((item) => (
            <li 
              key={item.value} 
              onClick={() => handleSelect(item)} 
              style={styles.menuItem}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function NumberDropdown({ label, value, onChange, min, max }) {
  return (
    <div style={dropdownStyles.container}>
      <label style={dropdownStyles.label}>{label}</label>
      <select 
        value={value} 
        onChange={onChange} 
        style={dropdownStyles.select}
      >
        {/* 최소값과 최대값 사이의 옵션만 렌더링 */}
        {KEY_OPTIONS.filter(option => option >= min && option <= max)
                     .map(option => (
          <option key={option} value={option}>
            {option} cm
          </option>
        ))}
      </select>
    </div>
  );
}

// ----------------------------------------------------
// 2. 키 설정 팝업 컴포넌트
// ----------------------------------------------------
function HeightSettingModal({ isOpen, onClose, onSave, initialMin, initialMax }) {
  // 팝업 내부에서 현재 선택된 최소/최대 키 상태를 관리
  const [minHeight, setMinHeight] = useState(initialMin);
  const [maxHeight, setMaxHeight] = useState(initialMax);
      

  // 저장 버튼 핸들러
  const handleSave = () => {
    // 최소 키가 최대 키보다 큰 경우 처리
    if (minHeight > maxHeight) {
        alert("최소 키는 최대 키보다 클 수 없습니다.");
        return;
    }
    onSave(minHeight, maxHeight); // 상위 컴포넌트로 값 전달
    onClose(); // 팝업 닫기
  };
if (!isOpen) return null;
// 팝업이 닫힌 상태면 아무것도 렌더링하지 않음

  return (
    <div style={modalStyles.backdrop}>
      <div style={modalStyles.content}>
        <h3 style={{ marginBottom: '20px' }}>키 범위 설정</h3>
        
        {/* 최소 키 드롭다운 */}
        <NumberDropdown
          label="최소 키"
          value={minHeight}
          onChange={(e) => setMinHeight(Number(e.target.value))}
          min={140}
          max={maxHeight} // 최소 키는 현재 최대 키를 넘을 수 없음
        />

        {/* 최대 키 드롭다운 */}
        <NumberDropdown
          label="최대 키"
          value={maxHeight}
          onChange={(e) => setMaxHeight(Number(e.target.value))}
          min={minHeight} // 최대 키는 현재 최소 키보다 작을 수 없음
          max={200}
        />

        <div style={modalStyles.buttonGroup}>
          <button onClick={onClose} style={modalStyles.closeButton}>닫기</button>
          <button onClick={handleSave} style={modalStyles.saveButton}>저장</button>
        </div>
      </div>
    </div>
  );
}

  // 3. 검색 버튼 클릭 또는 Enter 키 입력 시 실행되는 함수
  const handleSearch = (termToSearch) => {
    if (termToSearch.trim() === '') {
      alert('검색어를 입력해 주세요.');
      return;
    }
    // 여기에 실제 검색 API 호출 로직을 넣거나 상위 컴포넌트로 전달합니다.
setFinalSearchTerm(termToSearch); 

            setPosts([]);
        setPageKey(0); // offset을 0으로 초기화
        setHasMore(true);
        setButtonIndex(1);

   // fetchPosts()
  };

  // 4. Enter 키를 눌렀을 때 검색 함수를 실행하는 핸들러
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch(searchTerm);
    }
  };
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
    console.log(searchTerm)
  };

// ----------------------------------------------------
// 2. 메인 모달 컴포넌트
// ----------------------------------------------------


  const bannerSettings = {
    dots: true, // 하단에 점(dot) 페이지네이션 표시
    arrows: false, // 이전/다음 버튼 숨김
    infinite: true, // 무한 반복
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 3000,

    
  };



      const navigate = useNavigate();




  useEffect(() => {



    
    processData()

  }, []);

  useEffect(() => {
    // ⭐️ 모든 필터/검색 상태 중 하나라도 변경되면 이 블록이 실행됩니다.
    
    // 1. 상태 초기화
    setPosts([]);
    setPageKey(0); 
    setHasMore(true);

    

    // 2. 초기 로드 조건
    // (최소한의 필터 조건이 있을 때만 로드 시작, searchTerm이 빈 문자열이면 로드하지 않음)
    // minHeightState, maxHeightState는 기본값이 있으므로 제외하고, searchTerm 또는 genderTerm이 적용되었는지 확인합니다.

        fetchPosts(); 

    
    // 이 로그는 모든 필터 상태가 변경될 때마다 실행됩니다.
    console.log(`통합 필터 변경: Gender=${genderTerm}, SearchTerm=${searchTerm}, finalSelection=${finalSelection} seansonTerm=${seansonTerm}`);
    
// ⭐️ 의존성 배열에 API 로드에 필요한 모든 필터 상태를 넣습니다.
}, [finalSearchTerm, genderTerm,bodyTerm, seansonTerm,minHeightState, maxHeightState, finalSelection]); 






  //   const handleSaveHeightSettings = (min, max) => {
  //   setMinHeight(min.toString()); // API 요청을 위해 문자열로 저장
  //   setMaxHeight(max.toString());
  //   setIsModalOpen(false);
  //   // useEffect가 minHeight/maxHeight 변경을 감지하고 데이터를 초기화 후 재로딩함.
  // };


    // if (!dailylook) {
    // return <div>로딩 중...</div>;
  // }  


  const handleRemoveMood = (moodToRemove) => {
    // 삭제 후 상태 업데이트 및 API 호출 로직 트리거
    setFinalSelection(finalSelection.filter(mood => mood !== moodToRemove));
};

  const goBack = () => {
    // navigate(-1)을 호출하여 이전 경로로 이동
    navigate(-1);
  };

  const handleItemClick = (url) => {
        if (url) {
            window.open(url, '_blank');
        } else {
            console.log("URL이 없습니다.");
        }
    };

 return (
    <div style={styles.mobileContainer}>
      {/* 1. 헤더 영역 */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          
          {/* 알림 및 검색 아이콘 그룹 (좌/우 정렬) */}
          <div style={styles.iconWrapper}>
            <MdArrowBackIos size="24" onClick={goBack} style={styles.iconStyle} />
          </div>

                <div style={styles.searchContainer}>

                  <button onClick={() =>handleSearch(searchTerm)} style={styles.searchButton}>
                    <FaSearch size={20} color="#9b9b9bff" />
                  </button>

                  <input
                    type="text"
                    placeholder="해시태그 또는 사용자 아이디 검색"
                    value={searchTerm}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown} // Enter 키 이벤트 처리
                    style={styles.inputField}
                  />
                  
                  
                </div>
        </div>

      </header>

          <section style={styles.filterSection}>
                      
                      {/* 1. 드롭다운 필터 그룹 (가로 스크롤 가능하도록 flex 설정) */}
                      <div style={styles.dropdownsWrapper}>
                           
                         <Dropdown 
                              title={genderTerm == '' ? "성별" : 
                                
                                genderTerm == 'M'? '남성':
                                genderTerm == 'W'? '여성':
                                '전체'
                              } 
                              items={seletesex} 
                              type='g'
                              isOpen={openDropdown === 'g'}
                              onToggle={setOpenDropdown}
                            />
                            <Dropdown 
                              title={
                               bodyTerm ==''? "체형":
                               bodyTerm =='ALL'? '전체':
                               bodyTerm
                              }
                              items={seletebodytype} 
                              type='b' 
                              isOpen={openDropdown === 'b'}
                              onToggle={setOpenDropdown}
                            />
                          
                          {/* '키' 드롭다운을 팝업 버튼 대신 드롭다운 형태로 직접 넣거나 */}
                          {/* 팝업 버튼을 드롭다운 모양으로 스타일링 */}
                          
                          {/* 키 설정 버튼을 일반 드롭다운처럼 보이게 스타일링 */}
                           <div style={styles.dropdownContainer}>
                          <button 
                            onClick={() => setIsModalOpen(true)} 
                            style={styles.heightButton} // 새로운 스타일 적용
                          >
                             <div style={{marginLeft:'5px'}}>키</div> 
                             <span style={{    marginRight: '5px',
                                                fontSize: '10px',}}>▼</span>
                          </button>
                          </div>
                          <HeightSettingModal
                            isOpen={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            onSave={handleSaveSettings}
                            initialMin={minHeightState}
                            initialMax={maxHeightState}
                          />
                          
                          {/* 무드 드롭다운 버튼 (모달을 띄우는 버튼) */}
                          <div style={styles.dropdownContainer}>
                          <button 
                            onClick={() => setIsMoodModalOpen(true)} 
                            style={styles.moodButton} // 새로운 스타일 적용
                          >
                            무드<span style={styles.arrow}>▼</span>
                          </button>
                          </div>
                          <MoodSelectionModal
                            isOpen={isMoodModalOpen}
                            onClose={() => setIsMoodModalOpen(false)}
                            onConfirm={handleConfirmSelection}
                          />
                          
                          <Dropdown 
                            title={seansonTerm == '' ? "시즌":
                              seansonTerm=='ALL'? '전체':
                              seansonTerm


                            } 
                            items={seanson} 
                            type='s'
                            isOpen={openDropdown === 's'}
                            onToggle={setOpenDropdown}
                          />
                      </div>

                      {/* 2. 선택된 무드 태그 그룹 */}
                      <div style={styles.selectedTagsWrapper}>
                          {finalSelection.map((mood) => (
                              <div key={mood} style={styles.selectedTag}>
                                  <span>{mood}</span>
                                  {/* ⭐️ 삭제 버튼 */}
                                  <button 
                                    onClick={() => handleRemoveMood(mood)} 
                                    style={styles.removeTagButton}
                                  >
                                    &times;
                                  </button>
                              </div>
                          ))}
                      </div>

                  </section>

                          <div>
      
                  <br/>

                  <div style={{
    display: "flex",
    gap: "15px",
    marginBottom: "15px"
}}>                                       
                                        <div>
                                      <a style={{ 
                                        color: buttonIndex != 2 ? '#000000ff' : '#959595ff',
                                        fontSize: '1.2rem',
                                        fontWeight: 'bold',
                                      }} onClick={() => setButtonIndex(1)}>검색</a>
                                      <div style={{height: '2px',
                                      background: buttonIndex != 2 ? '#000000ff' : '#ffffffff',
                                      marginTop: '10px'
                                      }}></div>
                                      </div>
                                      <div>
                                      <a style={{ 
                                        color: buttonIndex == 2 ? '#000000ff' : '#959595ff',
                                        fontSize: '1.2rem',
                                        fontWeight: 'bold',
                                      }} onClick={() => setButtonIndex(2)}>MY 무드</a>
                                      <div style={{height: '2px',
                                        background: buttonIndex == 2 ? '#000000ff' : '#ffffffff',
                                        marginTop: '10px'
                                        }}></div>
                                      </div>
                                                      </div>
                  
                  
      {buttonIndex === 0 ? (
        <>
         
                    <div style={styles.popularKeywordsContainer}>
                    {popularKeywords.map((keyword, index) => (
                      <button
                        key={index}
                        style={styles.popularKeywordButton}
                        onClick={() => {
                          setSearchTerm(keyword);
                          handleSearch(keyword);
                        }}
                      >
                        {keyword.replace(/#/g,"")}
                      </button>
                    ))}
                  </div>   
            <div style={{textAlign:'center',marginTop:'50px'}}>데일리룩을 검색해보세요</div>
    </>
  ) 
  
  : buttonIndex === 1 ? (
                      <div>   
                    <div style={styles.popularKeywordsContainer}>
                    {popularKeywords.map((keyword, index) => (
                      <button
                        key={index}
                        style={styles.popularKeywordButton}
                        onClick={() => {
                          setSearchTerm(keyword);
                          handleSearch(keyword);
                        }}
                      >
                        {keyword.replace(/#/g,"")}
                      </button>
                    ))}
                  </div>        
                            <InfiniteScroll
                        dataLength={posts.length} // 현재 로드된 항목 수
                        next={fetchPosts}         // 스크롤이 끝에 도달하면 호출할 함수
                        hasMore={hasMore}  
                        scrollThreshold="60%"        // 더 불러올 데이터가 있는지 여부
                        loader={<h4 style={{ textAlign: 'center' }}>로딩 중...</h4>}
                        endMessage={<p style={{ textAlign: 'center' }}><b>모든 결과를 불러왔습니다.</b></p>}
                        //scrollableTarget="scrollableDiv" // 스크롤바가 있는 DOM 요소의 ID (없다면 window)
                      >
                        <div style={styles.postsGrid}>
                          {/* 포스트 목록 렌더링 */}
                          {posts.map((post, index) => (
                            <div key={index} style={styles.postItem}>
                              {/* 포스트 이미지 및 내용 표시 */}
                              <img src={post.thumbnail} alt={post.keyword} style={styles.postImage}
                                          onClick={() => goToPostDetail(post.id, 'd')}
                              
                              />
                              {post.more_images.length > 1?
                            <img src="/more.png" style={{ width: '25px', verticalAlign: 'middle',position:'absolute',top:"5px",right:'5px' }}/> : <></>
                              }
                              <p>{post.description}</p>
                            </div>
                          ))}
                        </div>
                      </InfiniteScroll>
                      </div>  
                      ) : buttonIndex === 2 ? (
                        <div>   
   
                            <InfiniteScroll
                        dataLength={moodposts.length} // 현재 로드된 항목 수
                        next={MoodfetchPosts}         // 스크롤이 끝에 도달하면 호출할 함수
                        hasMore={moodhasMore}  
                        scrollThreshold="60%"        // 더 불러올 데이터가 있는지 여부
                        loader={<h4 style={{ textAlign: 'center' }}>로딩 중...</h4>}
                        endMessage={
                          moodposts.length == 0?
                        
                        <p style={{ textAlign: 'center' }}><b>무드를 선택해 주세요.</b></p>
                        :
                        <p style={{ textAlign: 'center' }}><b>모든 결과를 불러왔습니다.</b></p>
                      
                      }
                        //scrollableTarget="scrollableDiv" // 스크롤바가 있는 DOM 요소의 ID (없다면 window)
                      >
                        <div style={styles.postsGrid}>
                          {/* 포스트 목록 렌더링 */}
                          {moodposts.map((post, index) => (
                            <div key={index} style={styles.postItem}>
                              {/* 포스트 이미지 및 내용 표시 */}
                              <img src={post.thumbnail} alt={post.keyword} style={styles.postImage}
                                          onClick={() => goToPostDetail(post.id, 'd')}
                              
                              />
                              {post.more_images.length > 1?
                    <img src="/more.png" style={{ width: '25px', verticalAlign: 'middle',position:'absolute',top:"5px",right:'5px' }}/> : <></>
                      }
                              <p>{post.description}</p>
                            </div>
                          ))}
                        </div>
                      </InfiniteScroll>
                      </div>  
  ) : (
    // 0, 1, 2 외의 모든 경우 (기본값)
    <div>인덱스 = {buttonIndex} (0, 1, 2 아님)</div>
  )}


                     
              </div>
      

    </div>

  );
}

// 스타일 객체 정의 (반응형 모바일에 적합하게)
const styles = {
    arrow: {
    marginLeft: '5px',
    fontSize: '10px',
  },

  filterSection: {
        // paddingTop은 헤더에 가려지지 않도록 이미 mainContent에서 처리되었으므로 필요 없음.
        padding: '10px 0',
        marginTop: '10px', // 헤더 영역과 검색창 아래 여백을 위해 임시 설정
    },
    
    // ⭐️ 드롭다운 컨테이너 (가로 스크롤 및 배치)
    dropdownsWrapper: {
        display: 'flex',
        //overflowX: 'scroll', // 가로 스크롤 가능
        paddingBottom: '10px',
        gap: '8px', // 드롭다운 버튼 사이 간격
        // 스크롤바 숨기기 (필요 시)
        // msOverflowStyle: 'none', // IE and Edge
        // scrollbarWidth: 'none', // Firefox
    },
    
    // ⭐️ 드롭다운 버튼 공통 스타일 (이미지처럼 검은 테두리와 흰 배경)
    dropdownButton: {
        // ... (기존 스타일 유지) ...
                color: '#333',
        border: '1px solid #333', // 검은색 테두리
        borderRadius: '8px',
        padding: '7px 7px',
        fontSize: '14px',
        whiteSpace: 'nowrap', // 버튼 내용 줄바꿈 방지

        
    },
    
    // ⭐️ 키 설정 버튼 스타일 (Dropdown과 동일하게 보이도록 복사)
    heightButton: {
        border: '1px solid #333',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: '#333',
        padding: '7px 7px',
        //fontSize: '14px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
                width :'58px',
        height:'32px',
        display:'flex',
        alignItems:'center',
        justifyContent:"space-between"
    },
    // ⭐️ 무드 설정 버튼 스타일 (Dropdown과 동일하게 보이도록 복사)
    moodButton: {
        border: '1px solid #333',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: '#333',
        padding: '7px 7px',
        //fontSize: '14px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
                width :'58px',
        height:'32px',
                        display:'flex',
        alignItems:'center',
        justifyContent:"space-between"
    },

    // ----------------- 선택된 태그 스타일 -----------------
    selectedTagsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginTop: '10px',
    },
    selectedTag: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fff0f0', // 이미지의 연한 핑크 배경
        color: '#333',
        padding: '6px 10px',
        borderRadius: '15px', // 둥근 모서리
        fontSize: '14px',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
    },
    removeTagButton: {
        marginLeft: '6px',
        backgroundColor: 'transparent',
        border: 'none',
        color: '#333',
        fontWeight: 'bold',
        fontSize: '12px',
        cursor: 'pointer',
        padding: 0,
        lineHeight: 1,
    },

container: {
        width: '100%',
        maxWidth: '400px', // 모바일 환경에 맞게 최대 너비 설정
        margin: '20px auto',
    },
    // 사진 속 둥근 박스 스타일
    itemBox: {
        display: 'flex',
        justifyContent: 'space-between', // 양 끝 정렬 (파트와 브랜드)
        alignItems: 'center',
        padding: '15px 20px',
        margin: '10px 0',
        backgroundColor: '#ffffff',
        borderRadius: '15px', // 둥근 모서리
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', // 약간의 그림자
        cursor: 'pointer', // 클릭 가능함을 표시
    },
    // 왼쪽 텍스트 그룹 (PART + 브랜드)
    leftGroup: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
    },
    // 오른쪽 브랜드/쇼핑몰 이름
    rightName: {
        fontSize: '16px',
        color: '#000000',
    },
    // '브랜드' 텍스트의 붉은색 스타일
    redText: {
        color: '#ff4d4f', // 빨간색 계열
        marginLeft: '5px',
        fontWeight: 'normal',
        fontSize: '14px',
    },


  feedContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        padding: '10px 15px',
    },
    controlPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    keywordInput: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    },
    filterButton: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #007bff',
        backgroundColor: '#fff',
        color: '#007bff',
        cursor: 'pointer',
    },
    resultTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        overflow: 'hidden',
        height: '160px',
        cursor:'pointer',
        position:'relative'
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
  mobileContainer: {
    maxWidth: '420px', // 일반적인 모바일 최대 너비
    margin: '0 auto',  // 중앙 정렬 (웹에서 볼 경우 대비)
    padding: '0 15px', // 좌우 패딩을 뷰포트 너비 기준으로 설정하여 반응성 확보
  },
  
  header: {
    paddingTop: '20px',
    //position:'fixed',
    top:'0',
    width:'100%',
    maxWidth:'420px',
    backgroundColor:'white',
    zIndex:'1'
  },
  
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between', // 요소들을 양 끝으로 분산
    alignItems: 'center',
  },
  
  logo: {
    width: '100px',
    // 로고는 중앙에 위치하도록 flexbox가 처리
  },
  
  iconWrapper: {
    // 아이콘 그룹을 위한 컨테이너 (각 아이콘에 개별 마진 대신 flex 사용)
    width: '30px', 
  },
  
  iconStyle: {
    // 아이콘 크기는 이미 24px로 설정됨
  },
  
  divider: {
    height: '1px', 
    backgroundColor: '#d4d4d4ff', 
    marginTop: '20px', // 수직 여백을 뷰포트 높이 기준으로 설정
  },

  infoSection: {

    justifyContent: 'space-between', // 주간모디 그룹과 임시 박스를 양 끝으로 분산
    alignItems: 'center',
    marginBottom: '5px',
    marginTop:'150px'
  },
  
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // 요소 사이의 간격
  },
  
  titleText: {
    color: '#000000ff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  infoIcon: {
    color: '#000000ff',
    cursor: 'pointer',
  },

  placeholderBox: {
    width: '70px',
    height: '20px',
    backgroundColor: 'rgb(0, 0, 0)',
    // flexbox가 자동으로 오른쪽 끝에 배치
  },
  
  bestTitle: {
    color: '#ff0000ff',
    fontSize: 'small',

    margin: '5px 0',
  },

  dailylooksGrid: {
    display: 'flex',
    justifyContent: 'space-between', // 두 이미지를 양 끝으로 분산
    gap: '10px', // 이미지 사이 간격
    marginTop: '10px',
  },

  dailylookImage: {
    width: '47%', // 컨테이너 너비의 49%를 차지 (간격 포함 100% 미만)
    //height: '59vw',
        borderRadius: '8px',
    objectFit: 'cover',

  },

  sliderContainer: {
      // 슬라이더 자체의 좌우 패딩을 모바일 컨테이너와 동일하게 맞추려면 padding: 0 이 필요할 수 있음
      // 여기서는 모바일 컨테이너의 패딩을 따름
      marginBottom: '20px',
      // slick-dots 커스터마이징을 위해 추가 CSS 필요
  },
  bannerLink: {
      display: 'block',
  },
  bannerImage: {
      width: '100%',
      height: '500px',
      borderRadius: '10px', // 이미지와 같은 모서리 둥글게 처리
      display: 'block', // 인라인 요소의 기본 여백 제거
  },

  defaultTag: {
    // 배경 및 텍스트 색상
    backgroundColor: '#333333', 
    color: '#ffffff',
    
    // 모서리 둥글게
    borderRadius: '10px', 
    
    // 내부 여백 (클릭 영역 확보)
    padding: '8px 15px', 
    
    // 글꼴 설정 (폰트에 따라 다를 수 있음)
    fontSize: '14px', 
    fontWeight: 'normal',
    
    // 기타 설정
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    
    // 옆 요소와의 간격
    marginRight: '10px', 
  },
  
  // 텍스트 밑줄 스타일 (이미지와 가장 유사하게 구현하기 위해 span에 적용)
  textUnderline: {
    // 텍스트와 거의 같은 색상의 얇은 밑줄 효과
    borderBottom: '1px solid #ffffff', 
    paddingBottom: '2px', // 텍스트와 밑줄 사이의 간격
  },
  
  // 선택되었을 때의 스타일 (필요하다면)
  // activeTag: {
  //   // defaultTag 스타일을 복사하고 필요한 부분만 변경 (예: 빨간색 테두리)
  //   ...this.defaultTag,
  //   // 예시: 선택 시 배경색 변경
  //   backgroundColor: '#111111', 
  // }
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px', // 컴포넌트의 최대 너비를 제한하여 모바일에 적합하게 조정
    //margin: '20px auto',
    //border: '1px solid #ccc',
    borderRadius: '10px', // 둥근 모서리
    overflow: 'hidden', // 버튼과 인풋필드를 묶음
    //boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    background: '#eeeeee'
  },
  inputField: {
    flexGrow: 1, // 입력 필드가 남은 공간을 모두 차지하도록
    padding: '10px 5px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: 1.5,
        background: '#eeeeee'
  },
  searchButton: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
  },

  dropdownContainer: {
    position: 'relative',
    display: 'inline-block', // 너비를 내용물에 맞춥니다.
  },
  dropdownButton: {
    padding: '7px 7px',
      border: '1px solid #333',
    borderRadius: '8px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
                    width :'58px',
        height:'32px',
                        color: '#333',

  },
  arrow: {
    marginLeft: '5px',
    fontSize: '10px',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // 버튼 바로 아래에 배치
    left: 0,
    zIndex: 1000,
    minWidth: '200%',
    padding: 0,
    margin: '4px 0 0 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    listStyle: 'none', // 리스트 마커 제거
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  menuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0', // 마우스 오버 시 배경색 변경 (인라인 스타일에서는 직접 구현 어려움)
    },
  },

    modalHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '5px',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'center',
  },
  tagsGrid: {
    display: 'flex',
    flexWrap: 'wrap', // 태그를 다음 줄로 넘김
    gap: '8px',       // 태그 간의 간격
    maxHeight: '400px', // 스크롤이 필요할 경우 최대 높이 지정
    overflowY: 'auto',
    padding: '10px 0',
  },
  tagBase: {
    padding: '8px 15px',
    borderRadius: '20px', // 타원형 모양을 위한 큰 BorderRadius
    border: '1px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  tagDefault: {
    backgroundColor: '#f0f0f0', // 비활성화된 태그 배경색 (연한 분홍색과 유사하게)
    color: '#333',
  },
  tagSelected: {
    backgroundColor: '#e64e4e', // 선택된 태그 배경색 (이미지의 빨간색)
    color: 'white',
    fontWeight: 'bold',
  },
  confirmButton: {
    width: '100%',
    padding: '15px 0',
    marginTop: '20px',
    backgroundColor: '#e64e4e', // 이미지와 같은 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  
  // 새로 추가된 스타일: 인기 검색어 컨테이너 (가로 배치)
  popularKeywordsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px', // 버튼 간 간격
    marginTop: '10px',
    marginBottom: '15px',
  },
  // 새로 추가된 스타일: 인기 검색어 버튼 (사진처럼 연한 핑크 배경, 빨간 텍스트, 둥근 모서리)
  popularKeywordButton: {
    backgroundColor: '#fff0f0', // 연한 핑크 배경
    color: '#ff0000', // 빨간 텍스트
    borderRadius: '20px', // 둥근 모서리
    padding: '8px 15px',
    border: 'none',
    fontSize: '14px',
    //fontWeight: 'bold',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  }
  


}
const dropdownStyles = {
  container: {
    marginBottom: '15px',
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#555',
  },
  select: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '16px',
    appearance: 'none', // 브라우저 기본 드롭다운 스타일 제거
  }
};

const modalStyles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '350px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
  },
  buttonGroup: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  closeButton: {
    padding: '10px 15px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#eee',
    cursor: 'pointer',
  },
  saveButton: {
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#007bff',
    color: 'white',
    cursor: 'pointer',
  },
};

const mainStyles = {
    openButton: {
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#f0f0f0',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '16px',
    }
}

export default Search;